import { ManageCustomFieldsController } from './manage-custom-fields.controller'

function manageCustomFields () {
  return {
    restrict: 'E',
    scope: {
      assets: '<',
      form: '=',
      flags: '='
    },
    templateUrl: '/repository/directives/manage-custom-fields/manage-custom-fields-directive.html?$$REVISION$$',
    controller: ManageCustomFieldsController
  }
}

export { manageCustomFields }
